<template>
  <div>

    <v-card flat class="ma-md-8 mt-md-2 rounded-lg pa-4">

      <v-skeleton-loader type="list-item@8" v-if="loading"></v-skeleton-loader>

      <div v-if="items.length === 0 && !loading">
        Er zijn geen mappen en formulieren gevonden voor deze klant.
      </div>

      <v-treeview
          v-model="tree"
          :open="initiallyOpen"
          :items="items"
          item-key="folder_id"
          open-on-click
          dense
          v-if="items"
      >
        <template v-slot:prepend="{ item, open }">
          <v-icon v-if="item.folder_name">
            {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
          </v-icon>
          <v-icon v-else>
            mdi-text-box-outline
          </v-icon>
        </template>
        <template v-slot:label="{item}">
          <v-sheet @click="itemClick(item)">
            <template v-if="item.folder_name">
              {{ item.folder_name }}
            </template>
            <template v-if="item.form_name">
              {{ item.form_name }}

              <form-description-tooltip :form="item" class="mr-1"></form-description-tooltip>

              <v-chip v-if="item.published_at" x-small color="primary">Gepubliceerd</v-chip>
              <v-chip v-else x-small outlined color="secondary">Niet gepubliceerd</v-chip>
            </template>
          </v-sheet>
        </template>
      </v-treeview>

    </v-card>

  </div>
</template>

<script>
import userHelpers from "@/mixins/userHelpers";
import axios from "axios";
import FormDescriptionTooltip from "@/components/FormDescriptionTooltip.vue";

export default {
  name: "ListFormsAdmin",
  components: {
    FormDescriptionTooltip,
  },
  mixins: [
    userHelpers,
  ],
  props: {
    // Optional prop to open a subfolder
    form_folder: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      loading: true,
      tree: [],
      initiallyOpen: ['public'],
      items: [],
    }
  },
  async created() {
    await this.getDataFromApi()
  },
  methods: {
    async getDataFromApi() {
      this.loading = true;

      try {
        let client_id = this.$store.getters.CurrentClient;
        let response = await axios.get('/api/client/'+client_id+'/folder/admin');
        this.items = response.data;

      } catch (error) {
        console.log(error);
      }
      finally {
        this.loading = false;
      }
    },
    itemClick(item) {
      // Open form if it's a form
      if (item.form_id) {
        this.$router.push({ name: 'form_view', params: {form_id: item.form_id} })
      }
    },
  },
}
</script>

<style scoped>

</style>